class ComponentSlider extends Theme.Component {

  connectedCallback() {
    this.slider = new Flickity(this.elements.slider, {
      cellAlign: "center",
      contain: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false
    });

    window.addEventListener('load', () => this.slider.resize(), { once: true });

    this.events();
  }

  next() {
    this.slider.next();
  }

  previous() {
    this.slider.previous();
  }
}

customElements.define("component-slider", ComponentSlider);